import { fetchBasicJsonPostJson, fetchBasicJsonPost } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        filter.kod = filter.kod || null;
        filter.kod1 = filter.kod1 || null;
        filter.branch_code = filter.branch_code || null;
        filter.department_code = filter.department_code || null;
        filter.person_code = filter.person_code || null;
        filter.variant = filter.variant || null;
        return fetchBasicJsonPostJson(
            '/Price/GetDataTableData',
            { data: Object.assign(filter, parameters), signal: signal },
            { useBlock: !signal }
        );
    },
    add: item => fetchBasicJsonPost('/Price/Add', { data: item }),
    edit: item => fetchBasicJsonPost('/Price/Edit', { data: item }),
    delete: item => fetchBasicJsonPost('/Price/Delete', { data: item }),
    uploadData: (parameters, useBlock) =>
        fetchBasicJsonPost(
            '/Price/UploadBatch',
            {
                data: {
                    date: parameters.date,
                    nosologies: parameters.nosologies,
                    insurance_discounts: parameters.insurance_discounts,
                    prices: parameters.prices,
                    price_by_doctor: parameters.priceByDoctor
                }
            },
            { useBlock: useBlock === true }
        )
};
